// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getPipProducts} from '../../shared/repositories';
import {readPipDetails} from './get-pip-details';

export const readPipProducts = (pin, pipId) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getPipProducts(pin);

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_PIP_PIP_PRODUCTS
            });

            if (pipId) {

                readPipDetails(pipId, true)(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/get-pip-products.js